import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Briefcase } from 'lucide-react';
const roles = [{
  period: '2014 – Present',
  title: 'Chief Executive Officer',
  org: 'Utah Medical Association',
  points: ['Grew membership through modernized engagement and value programs', 'Drove significant revenue growth across dues, programs, and events', 'Expanded the association foundation and launched new scholarships', 'Led physician workforce initiatives and statewide healthcare advocacy']
}, {
  period: '2010 – 2014',
  title: 'Assistant EVP & Director of Government Relations',
  org: 'Utah Medical Association',
  points: ['Delivered legislative success across multiple sessions', 'Built government relations and stakeholder engagement strategy', 'Advanced healthcare policy priorities at the state level']
}, {
  period: '2007 – 2010',
  title: 'Executive Director',
  org: 'Utah Ambulatory Surgery Center Association',
  points: ['Founded the organization from inception', 'Developed governance structure and bylaws', 'Launched advocacy initiatives for ambulatory care']
}, {
  period: '2003 – 2007',
  title: 'Chief Operating Officer',
  org: 'Utah Hospital Association For-Profit Services Corp',
  points: ['Led statewide collaboration initiatives', 'Developed workforce solutions for member hospitals', 'Drove operational improvement and efficiency']
}, {
  period: '1999 – 2003',
  title: 'Director of Finance & IT Services',
  org: 'Healthcare Organization',
  points: ['Held CFO-level responsibilities and financial oversight', 'Led Medicaid initiatives and reimbursement strategy', 'Directed audit leadership and financial reporting']
}];
export function Experience() {
  useEffect(() => {
    document.title = 'Executive Experience | Michelle McOmber Healthcare Leadership';
  }, []);
  return <div className="w-full bg-slate-50 min-h-screen" data-id="element-280">
      <header className="bg-navy-900 text-white py-20" data-id="element-281">
        <div className="max-w-7xl mx-auto px-6" data-id="element-282">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-283">
            <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4 text-white" data-id="element-284">
              Executive Experience
            </h1>
            <p className="text-xl text-slate-300 max-w-2xl" data-id="element-285">
              Two decades of progressive healthcare leadership across finance,
              operations, advocacy, and the CEO suite.
            </p>
          </motion.div>
        </div>
      </header>

      <section className="py-24" data-id="element-286">
        <div className="max-w-5xl mx-auto px-6" data-id="element-287">
          <div className="space-y-16" data-id="element-288">
            {roles.map((role, i) => <motion.div key={role.title} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.06
          }} className="relative pl-16" data-id="element-289">
                <span className="absolute left-0 top-0 w-12 h-12 rounded-full bg-white border-4 border-slate-50 shadow-md flex items-center justify-center text-gold" data-id="element-290">
                  <Briefcase className="w-5 h-5" data-id="element-291" />
                </span>
                <div className="bg-white p-8 rounded-xl shadow-sm border border-slate-100 hover:shadow-lg transition-shadow" data-id="element-292">
                  <p className="text-gold font-bold text-sm tracking-wider mb-2" data-id="element-293">
                    {role.period}
                  </p>
                  <h2 className="text-2xl font-serif font-bold text-navy-900 mb-1" data-id="element-294">
                    {role.title}
                  </h2>
                  <p className="text-lg text-slate-600 font-medium mb-6" data-id="element-295">
                    {role.org}
                  </p>
                  <ul className="space-y-3" data-id="element-296">
                    {role.points.map(p => <li key={p} className="flex items-start text-slate-600" data-id="element-297">
                        <span className="w-1.5 h-1.5 rounded-full bg-navy-900 mt-2 mr-3 shrink-0" data-id="element-298" />
                        <span className="leading-relaxed" data-id="element-299">{p}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
    </div>;
}